import { EventResponseWithChapters } from 'api';

export const exploreAccessRedirect = (
  event: EventResponseWithChapters | undefined,
) =>
  event?.eventType === 'INSIGHTS_EXPLORE' ? `/experiences/${event.id}` : null;
